import { render, staticRenderFns } from "./NotRegisteredStandardTable.vue?vue&type=template&id=6a092129"
import script from "./NotRegisteredStandardTable.vue?vue&type=script&lang=js"
export * from "./NotRegisteredStandardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports